import { type IUseColumnWidthLockParams, useColumnWidthLock } from '../../lib/useColumnWidthLock'

export type IColumnWidthLockProps = IUseColumnWidthLockParams

export const ColumnWidthLock = (props: IColumnWidthLockProps) => {
  const { applyLock, renderColgroup } = useColumnWidthLock(props)

  return applyLock ? renderColgroup() : null
}
